import { render, staticRenderFns } from "./PaletteView.vue?vue&type=template&id=73b95f5c&scoped=true&"
import script from "./PaletteView.ts?vue&type=script&lang=ts&"
export * from "./PaletteView.ts?vue&type=script&lang=ts&"
import style0 from "./PaletteView.vue?vue&type=style&index=0&id=73b95f5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b95f5c",
  null
  
)

export default component.exports